 export const RecruitmentProcessData = [
    { fname: "Emilia", profession: "Content Writer", status: "Interview" },
    { fname: "Mike Tyler", profession: "Administrative Assistent", status: "Resume" },
    { fname: "marie Arch", profession: "Socialmedia Manager", status: "Interview" },
    { fname: "Sandra huffman", profession: "Customer Services ", status: "Clered" },
    { fname: "Rose Gilbert", profession: "Content Writer", status: "Task" },
    { fname: "Jessica Miller", profession: "Lead Designer", status: "Cleared" },
    { fname: "Emilia", profession: "Content Writer", status: "Interview" },
  ];
  export const RecPrHeading=[
    {heading:'Full name'},
     {heading: 'Profession'},
     {heading:'Status'}
  ]
  export const title =[
   { name:'Requirment Process'}
  ]